import { render, staticRenderFns } from "./partyOnline.vue?vue&type=template&id=10b13d56&scoped=true"
import script from "./partyOnline.vue?vue&type=script&lang=js"
export * from "./partyOnline.vue?vue&type=script&lang=js"
import style0 from "./partyOnline.vue?vue&type=style&index=0&id=10b13d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b13d56",
  null
  
)

export default component.exports